var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEfbDescentCalculatorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124.24mm",
    height: "63.445mm",
    viewBox: "0 0 124.24 63.445",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.878 -116.78)",
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.603 138.21h-9.2589v26.509h-7.3346v-26.509h-9.2136v-5.9537h25.807z",
    fill: "#fff",
    opacity: 0.75,
    strokeWidth: 7.7271
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.97 165.29q-6.9724 0-11.364-4.5276-4.3917-4.5502-4.3917-11.84 0-7.6968 4.4596-12.451 4.4596-4.7539 11.817-4.7539 6.9498 0 11.228 4.5502 4.3012 4.5502 4.3012 11.998 0 7.6516-4.4596 12.338-4.437 4.686-11.591 4.686zm0.31693-27.279q-3.8484 0-6.1122 2.8976-2.2638 2.875-2.2638 7.6289 0 4.8218 2.2638 7.6289 2.2638 2.8071 5.9311 2.8071 3.7805 0 5.999-2.7165 2.2185-2.7392 2.2185-7.5837 0-5.0482-2.1506-7.8553-2.1506-2.8071-5.8858-2.8071z",
    fill: "#fff",
    opacity: 0.75,
    strokeWidth: 7.7271
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.41 164.72v-32.463h11.5q17.295 0 17.295 15.824 0 7.5837-4.7313 12.111-4.7087 4.5276-12.564 4.5276zm7.312-26.509v20.578h3.622q4.7539 0 7.4478-2.8524 2.7165-2.8524 2.7165-7.7648 0-4.6408-2.6939-7.2894-2.6713-2.6713-7.5158-2.6713z",
    fill: "#fff",
    opacity: 0.75,
    strokeWidth: 7.7271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.201,
    y: 118.1,
    width: 121.6,
    height: 60.799,
    fillOpacity: 0,
    opacity: 0.75,
    stroke: "#fff",
    strokeWidth: 2.6458
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfbDescentCalculatorLogo);
export default __webpack_public_path__ + "static/media/efb-descent-calculator-logo.0fff1d4a08e5963615ecf4bc0d83419e.svg";
export { ForwardRef as ReactComponent };